import _ from 'common/customLodash';

class EventEmitter {
    constructor() {
        this.listeners = {};
    }

    on(name, listener) {
        if (!this.listeners[name]) {
            this.listeners[name] = [];
        }

        this.listeners[name].push(listener);
    }

    off(name, listener) {
        if (!this.listeners[name]) {
          return;
        }

        _.remove(this.listeners[name], listener);
    }

    emit(name, ...args) {
        if (!this.listeners[name]) {
          return;
        }

        this.listeners[name].forEach(l => l.apply(this, args));
    }
}

export default EventEmitter;



// WEBPACK FOOTER //
// ./src/common/eventEmitter.js